export const POSTER_WIDTH = 108;
export const POSTER_HEIGHT = 76;
export const DATA_TEST_IDS = {
  ROOT: (id: string) => `mediafile_poster_root_${id}`,
  IMAGE: (id: string) => `mediafile_poster_image_${id}`,
  FORMAT: (id: string) => `mediafile_poster_format_${id}`,
  DURATION: (id: string) => `mediafile_poster_duration_${id}`,
  SOUND: (id: string) => `mediafile_poster_sound_${id}`,
  EMENU: (id: string) => `mediafile_poster_emenu_${id}`,
  PREVIEW: (id: string) => `mediafile_poster_preview_${id}`,
  PREVIEW_CONTENT: (id: string) => `mediafile_poster_preview_content_${id}`,
  PREVIEW_EYE: (id: string) => `mediafile_poster_preview_eye_${id}`,
};
